import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With your role at QFCRA overseeing both authorisation and supervision, you've
                helped shape a robust regulatory environment in the Qatar Financial Centre. What are
                the key principles guiding your approach to ensuring effective and risk-based
                supervision across the financial institutions operating within the QFC?
              </strong>
            </h5>

            <h5 className="text-white">
              The most important principle is proportionality – we achieve this by adopting a
              principles-based approach (rather than rules) adjusted for the risk-rating of the
              regulated firm.
              <br />
              <br />
              The second principle is to act collaboratively – the success (or failure) of our firms
              is ours too. We seek first to understand, then to be understood.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As financial institutions adopt new technologies and business models, regulatory
                frameworks must keep pace without stifling growth. How does QFCRA strike a balance
                between fostering innovation—such as fintech and digital banking—and maintaining
                regulatory stability and consumer protection?
              </strong>
            </h5>
            <h5 className="text-white">
              Our primary point of departure is that we regulate the activity, not the manner is
              which it is delivered. Linking back to the principle of collaboration, we need to
              understand the pertinent risks associated with an activity and adapt our approach to
              address any risks that may arise from the method of delivery.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve led initiatives that promote transparency and market integrity across
                financial services in Qatar. What measures are most critical today to sustain trust
                in the financial system, particularly amid rising global regulatory expectations and
                digital disruption?
              </strong>
            </h5>
            <h5 className="text-white">
              Most important is the necessity to engage with other regulators through active
              participation in the fora established for this purpose. We do not seek to reinvent the
              wheel, but rather to adopt best practices as demonstrated and discussed in such fora.
              Promoting and facilitating disclosure by regulators and market participants is
              imperative.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-QFCRA is recognized for aligning its standards with international regulatory
                frameworks. How do you ensure that Qatar’s regulatory framework remains aligned with
                evolving global norms while being tailored to the region’s unique financial
                landscape?
              </strong>
            </h5>
            <h5 className="text-white">
              As already mentioned, active participation in international fora and maintaining
              dialogue with market participants to adopt a proportional approach to regulation and
              supervision helps us maintain alignment while accommodating and adjusting for
              idiosyncrasies.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your career bridges both regulatory and institutional perspectives, giving you a
                well-rounded view of the evolving financial ecosystem. In your view, how is the role
                of financial regulators changing in the digital era, and what new capabilities must
                regulators develop to remain effective?
              </strong>
            </h5>
            <h5 className="text-white">
              It is essential for regulators to investigate and adopt new technologies. Reliance on
              subject-matter experts must be extended in the spirit of mutual learning. It is ideal
              for supervision teams to include individuals that have financial industry and
              information technology experience.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
